import React from 'react';

import { Typography } from '@material-ui/core';
import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, Step } from '../SteppedForm';

const StepCamera = (props) => {
  return (
    <Step
      id="camera"
      title="Cameras"
      nonext
      skip={(formdata) =>
        formdata.onboardcar === false || formdata.tiger === true || props.getVehicle().carbuy
      }>
      <Typography variant="body1" class="formQuestion">
        Do you need cameras for this vehicle?
      </Typography>
      {/* <Typography variant="body1" variant="body1">Do you want { props.state.formdata.network } to supply cameras for this vehicle?</Typography> */}
      <ButtonField
        id="camera"
        value={true}
        label="Yes"
        className="TopIconButton"
        startIcon={<CheckOutlinedIcon />}
      />
      <ButtonField
        id="camera"
        value={false}
        label="No"
        className="TopIconButton"
        startIcon={<ClearOutlinedIcon />}
      />
    </Step>
  );
};

export default StepCamera;
